import styled, { keyframes } from "styled-components";

const theme = {
  bg: "#F4F7FC",
  surface: "#FFFFFF",
  surfaceDark: "#252836",
  accent: "#6C63FF",
  primary: "#00D97E",
  text: "#171A1E",
  textSecondary: "#6B7280",
  border: "#E5E7EB",
  infoBg: "#E3F2FD",
  infoText: "#0D47A1",
};

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
`;

const popIn = keyframes`
  0% { opacity: 0; transform: scale(0.9); }
  100% { opacity: 1; transform: scale(1); }
`;

const shimmer = keyframes`
  0% { background-position: -1000px 0; }
  100% { background-position: 1000px 0; }
`;

const pulse = keyframes`
  0% { box-shadow: 0 0 0 0 rgba(37, 211, 102, 0.4); }
  70% { box-shadow: 0 0 0 10px rgba(37, 211, 102, 0); }
  100% { box-shadow: 0 0 0 0 rgba(37, 211, 102, 0); }
`;

export const SaquePageContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  padding: 2rem 3rem;
  box-sizing: border-box;
  background-color: ${theme.bg};
  animation: ${fadeIn} 0.5s ease-out;

  @media (max-width: 768px) {
    padding: 1rem;
  }
`;

export const Header = styled.header`
  margin-bottom: 2rem;
`;

export const Title = styled.h1`
  font-size: 2.5rem;
  color: ${theme.text};
  margin: 0;

  @media (max-width: 768px) {
    font-size: 1.8rem;
  }
`;

export const WalletCard = styled.div`
  background: ${theme.surface};
  border-radius: 16px;
  padding: 2rem;
  box-shadow: 0 10px 30px rgba(108, 99, 255, 0.1);
  border: 1px solid ${theme.border};
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 2rem;
  align-items: center;
  margin-bottom: 2rem;

  @media (max-width: 768px) {
    padding: 1.5rem;
    gap: 1.5rem;
  }
`;

export const BalanceGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;

  &.main-balance {
    grid-column: 1 / -1;
    text-align: center;
    border-bottom: 1px solid ${theme.border};
    padding-bottom: 2rem;

    @media (min-width: 768px) {
      grid-column: 1 / span 2;
      text-align: left;
      border-right: 1px solid ${theme.border};
      border-bottom: none;
      padding-bottom: 0;
      padding-right: 2rem;
    }
  }
`;

export const BalanceLabel = styled.span`
  font-size: 0.9rem;
  color: ${theme.textSecondary};
  font-weight: 500;
  text-transform: uppercase;
`;

export const BalanceValue = styled.h2`
  font-size: 3rem;
  color: ${theme.primary};
  margin: 0;
  font-weight: 700;

  @media (max-width: 768px) {
    font-size: 2.2rem;
  }
`;

export const BalanceSubValue = styled.p`
  font-size: 1.5rem;
  color: ${theme.text};
  margin: 0;
  font-weight: 600;

  @media (max-width: 768px) {
    font-size: 1.2rem;
  }
`;

export const ActionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const ActionButton = styled.button`
  width: 100%;
  padding: 1rem;
  font-size: 1rem;
  font-weight: 600;
  border-radius: 8px;
  cursor: pointer;
  border: none;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;

  &.primary {
    background: ${theme.accent};
    color: white;
  }

  &.secondary {
    background: ${theme.border};
    color: ${theme.text};
  }

  &:hover:not(:disabled) {
    transform: translateY(-3px);
  }
`;

export const InfoCard = styled.div`
  background-color: ${theme.infoBg};
  border-left: 4px solid ${theme.accent};
  border-radius: 8px;
  padding: 1.5rem;
  display: flex;
  gap: 1rem;
  margin-bottom: 2rem;

  @media (max-width: 768px) {
    padding: 1rem;
  }
`;

export const InfoText = styled.div`
  color: ${theme.infoText};
  font-size: 0.95rem;
  line-height: 1.5;
`;

export const TabelaContainer = styled.div`
  background-color: ${theme.surfaceDark};
  color: #f8f8f2;
  border-radius: 16px;
  padding: 30px;
  box-sizing: border-box;

  @media (max-width: 768px) {
    padding: 15px;
  }
`;

export const TabelaHeader = styled.div`
  padding: 1.5rem 0;
  border-bottom: 1px solid #44475a;

  h2 {
    font-size: 1.5rem;
    color: #f8f8f2;
  }
`;

/* --- MODAL RESPONSIVO CORRIGIDO --- */

export const AdOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.9);
  backdrop-filter: blur(8px);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px; /* Padding menor para dar mais espaço no mobile */
  box-sizing: border-box;
`;

export const AdContainer = styled.div`
  width: 100%;
  max-width: 450px;
  background: linear-gradient(135deg, #0f172a 0%, #000000 100%);
  border-radius: 24px;
  position: relative;
  padding: 40px 25px;
  text-align: center;
  border: 1px solid rgba(212, 175, 55, 0.3);
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.5);
  overflow: hidden;
  animation: ${popIn} 0.4s ease-out;
  box-sizing: border-box; /* Garante que padding não estoure a largura */

  @media (max-width: 480px) {
    padding: 35px 15px;
    border-radius: 20px;
    max-width: 100%; /* Ocupa o máximo permitido pelo padding do overlay */
  }

  .shine-effect {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      to right,
      transparent 0%,
      rgba(255, 255, 255, 0.05) 50%,
      transparent 100%
    );
    animation: ${shimmer} 3s infinite linear;
    pointer-events: none;
  }
`;

export const AdCloseButton = styled.button`
  position: absolute;
  top: 12px;
  right: 12px;
  background: rgba(255, 255, 255, 0.1);
  border: none;
  color: white;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  cursor: pointer;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const AdContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  width: 100%;

  .icon-wrapper {
    width: 60px;
    height: 60px;
    background: rgba(255, 255, 255, 0.03);
    border-radius: 50%;
    padding: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  h2 {
    color: #ffd700;
    margin: 0;
    font-size: 24px;
    font-weight: 900;
    width: 100%;

    @media (max-width: 480px) {
      font-size: 20px;
    }
  }

  .text-block {
    color: #d1d5db;
    width: 100%;

    p {
      margin: 8px 0;
      line-height: 1.5;
      font-size: 15px;

      @media (max-width: 480px) {
        font-size: 14px;
      }
    }

    .highlight {
      font-size: 17px;
      color: white;
      font-weight: 500;

      @media (max-width: 480px) {
        font-size: 15px;
      }
    }

    strong {
      color: #ffffff;
    }
  }
`;

export const AdButtons = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  margin-top: 10px;

  button {
    width: 100%;
    padding: 15px 10px;
    border-radius: 12px;
    font-weight: 800;
    cursor: pointer;
    transition: all 0.3s;
    font-size: 13px;
    text-transform: uppercase;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    box-sizing: border-box;

    @media (max-width: 480px) {
      padding: 14px 8px;
      font-size: 11px; /* Fonte levemente menor para garantir que caiba em uma linha */
    }
  }

  .btn-whatsapp {
    background: #25d366;
    border: none;
    color: #fff;
    animation: ${pulse} 2s infinite;

    &:hover {
      filter: brightness(1.1);
    }
  }

  .btn-link {
    background: transparent;
    border: 1px solid rgba(255, 255, 255, 0.15);
    color: #9ca3af;
    font-size: 12px;
    text-transform: none;
    font-weight: 400;

    &:hover {
      color: #fff;
      border-color: rgba(255, 255, 255, 0.4);
    }
  }
`;
